import { PaginatedApiResponse, TechnicianRecurringAvailabilityEntry } from 'types';
import { baseQuery } from '../baseQuery';
import { QueryFunctionContext } from '@tanstack/react-query';

type getTechnicianAwayStatusesParams = {
  technicianId?: string;
  page?: number;
  per_page?: number;
};

export const getTechnicianAwayStatuses = async ({
  queryKey,
}: QueryFunctionContext<[string, getTechnicianAwayStatusesParams]>): Promise<
  PaginatedApiResponse<TechnicianRecurringAvailabilityEntry[]>
> => {
  const [, params] = queryKey;
  const { technicianId, page = 1, per_page = 5 } = params;

  const queryParams = new URLSearchParams();
  queryParams.append('page', page.toString());
  queryParams.append('per_page', per_page.toString());

  const url = `technicians/${technicianId}/away-statuses?${queryParams.toString()}`;

  const data: PaginatedApiResponse<TechnicianRecurringAvailabilityEntry[]> = await baseQuery(url);

  return data;
};
